import { render, staticRenderFns } from "./CardManagement.vue?vue&type=template&id=59108e43&scoped=true&"
import script from "./CardManagement.vue?vue&type=script&lang=js&"
export * from "./CardManagement.vue?vue&type=script&lang=js&"
import style0 from "./CardManagement.vue?vue&type=style&index=0&id=59108e43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59108e43",
  null
  
)

export default component.exports